// Function index:
//   getUserUsage(period) — fetch per-user usage stats for a period.
//
// Returns daily/weekly/monthly/all-time token and USD breakdown by model.

import { getJson } from './http.js';

export interface UserUsageData {
  period: 'today' | 'week' | 'month' | 'all';
  start_date: string;
  end_date: string;
  tokens_by_model: Record<string, { input_tokens: number; output_tokens: number }>;
  usd_by_model: Record<string, number>;
  total_usd: number;
}

export const getUserUsage = (period: string): Promise<UserUsageData> =>
  getJson(`/api/user/usage?period=${encodeURIComponent(period)}`);
